import { render, staticRenderFns } from "./FormPage2.vue?vue&type=template&id=63b59f4d&scoped=true&"
import script from "./FormPage2.vue?vue&type=script&lang=js&"
export * from "./FormPage2.vue?vue&type=script&lang=js&"
import style0 from "./FormPage2.vue?vue&type=style&index=0&id=63b59f4d&scoped=true&lang=css&"
import style1 from "./FormPage2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b59f4d",
  null
  
)

export default component.exports